import React from "react";
import { CircularProgress, Dialog, DialogContent } from "@mui/material";
//Import Breadcrumb

const LoadingDialog = ({ open }) => {
    return (
        <React.Fragment>
            <Dialog
                open={open}
                PaperProps={{ sx: { padding: 1 } }}
            >
                <DialogContent style={{color: 'var(--bs-theme-color)'}}>
                    <CircularProgress color="inherit"/>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default LoadingDialog;
